(() => {
  if (window.PixioWaveQuickAddReady) return;
  window.PixioWaveQuickAddReady = true;

  const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const drawerSelector = 'cart-drawer-component, cart-drawer, #CartDrawer, [data-cart-drawer]';
  const bubbleSelector = 'cart-icon, #cart-icon-bubble, .cart-count-bubble, [data-cart-count]';

  const sectionIdOf = (element) => {
    const wrapper = element && element.closest('[id^="shopify-section-"]');
    return wrapper ? wrapper.id.replace('shopify-section-', '') : null;
  };

  const applySections = (sections) => {
    if (!sections) return;

    Object.entries(sections).forEach(([id, html]) => {
      const wrapper = document.getElementById(`shopify-section-${id}`);
      if (!wrapper || typeof html !== 'string') return;

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.getElementById(`shopify-section-${id}`) || parsed.body;
      wrapper.innerHTML = fresh.innerHTML;
    });
  };

  const openCartDrawer = () => {
    const drawer = document.querySelector(drawerSelector);
    if (drawer) {
      for (const method of ['open', 'showDialog', 'show']) {
        if (typeof drawer[method] === 'function') {
          drawer[method]();
          return;
        }
      }
    }

    const trigger =
      document.querySelector('[data-testid="cart-drawer-trigger"]') ||
      document.querySelector('cart-drawer-component [on\\:click="/open"]') ||
      document.querySelector('[data-cart-drawer-trigger]');

    if (trigger) trigger.click();
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-pxwave-cart-form]');
    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-pxwave-cart-status]');
    const variantInput = form.querySelector('[name="id"]');
    if (!button || !variantInput || button.disabled) return;

    const variantId = Number(variantInput.value);
    const originalLabel = button.textContent;
    const sectionIds = [
      ...new Set(
        [
          sectionIdOf(document.querySelector(drawerSelector)),
          sectionIdOf(document.querySelector(bubbleSelector))
        ].filter(Boolean)
      )
    ];

    button.disabled = true;
    button.textContent = form.dataset.addingLabel || 'Adding…';
    form.setAttribute('aria-busy', 'true');
    if (status) status.textContent = '';

    try {
      const payload = { id: variantId, quantity: 1 };
      if (sectionIds.length) {
        payload.sections = sectionIds.join(',');
        payload.sections_url = window.location.pathname;
      }

      const response = await fetch(`${rootUrl}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      const result = await response.json().catch(() => null);

      if (!response.ok) {
        throw new Error(
          (result && (result.description || result.message)) || form.dataset.errorLabel || 'Unable to add this item'
        );
      }

      const cart = await fetch(`${rootUrl}cart.js`, { headers: { Accept: 'application/json' } })
        .then((cartResponse) => cartResponse.json())
        .catch(() => null);

      applySections(result && result.sections);

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: form.closest('[id]')?.id || 'PixioWaveQuickAdd',
            data: {
              source: 'PixioWaveQuickAdd',
              itemCount: cart ? cart.item_count : undefined,
              variantId,
              sections: result && result.sections
            }
          }
        })
      );
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      if (status) status.textContent = form.dataset.addedLabel || 'Added to cart';
      openCartDrawer();
    } catch (error) {
      if (status) status.textContent = error.message || form.dataset.errorLabel || 'Unable to add this item';
    } finally {
      button.disabled = false;
      button.textContent = originalLabel;
      form.removeAttribute('aria-busy');
    }
  });
})();
